import { gql } from '@apollo/client';

export const GET_NOTIFICATION = gql`
    query getNotification($paging: PagingInput!, $id: ID) {
        getNotification(input: { paging: $paging, id: $id }) {
            data {
                id
                verb
                actor
                recipient
                targetObjectId
                targetObjectType
                message
                actionObjectType
                actionObjectId
                read
                creator
                created
                updater
                updated
            }
            unreadCount
        }
    }
`;
